<dl class="fs-mb-none stats">
  <div>
    <ng-container *ngFor="let property of data.camera.properties | keyvalue">
      <ng-container *ngIf="!exclude(property.key) && !!property.value">
        <dt>{{ toStartCase(property.key) }}:</dt>
        <dd class="fs-text-wrap">
          <span *ngIf="property.value?.length > 120; else text">
            <div matTooltipPosition="right" matTooltipClass="details" [matTooltip]="property.value">
              {{ property.value.substring(0, 120) }}...
            </div>
          </span>
          <ng-template #text>
            <ng-container
              *ngIf="
                (property.value && property.key.toString().toLowerCase().includes('date')) ||
                  (property.value && property.key.toString().toLowerCase().includes('last'));
                else defaultTmpl
              "
            >
              {{ formatDate(property.value) | fsFormatDate : 'mediumDate' }}
            </ng-container>
            <ng-template #defaultTmpl>
              <ng-container *ngIf="property.key?.toLowerCase() === 'up'; else defaultTextTmpl">
                {{ property.value ? ('common.active' | t) : ('liveView.liveViewer.inactive' | t) }}
              </ng-container>
              <ng-template #defaultTextTmpl>
                {{ property.value }}
              </ng-template>
            </ng-template>
          </ng-template>
        </dd>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="data.camera.link">
      <dt>{{ 'vehicleIntelligence.link' | t }}:</dt>
      <dd class="fs-text-wrap">
        <a [href]="data.camera.link" target="_blank">{{ data.camera.link }}</a>
      </dd>
    </ng-container>
  </div>
  <div>
    <sn-icon-button [matMenuTriggerFor]="viewOptionsMenu" class="menu">
      <sn-icon>more_vert</sn-icon>
    </sn-icon-button>
  </div>
</dl>

<mat-menu #viewOptionsMenu="matMenu">
  <button *ngIf="canEditLpr" mat-menu-item (click)="editHeading(data.camera)">
    <sn-icon fontSet="fal" fontIcon="fa-pencil"></sn-icon>
    <span>{{ 'cameras.editCamera' | t }}</span>
  </button>
</mat-menu>
